exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root {\r\n  --navbar-height: 50px;\r\n}\r\n", ""]);

// exports
